export const extendedErrorLogProtocolLimit = 100;

export const getCountLimit = () => extendedErrorLogProtocolLimit;

export const isErrorCountExceeds = (errorCount: number): boolean => errorCount >= extendedErrorLogProtocolLimit;
